"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    return window && window.location ? window.location.pathname : null;
}
exports.default = default_1;
